/** @jsxImportSource @emotion/react */
import _ from "lodash";
import { useCallback } from "react";
import { BrowserRouter, useNavigate, useSearchParams } from "react-router-dom";

import { ComponentFilterProps, FilterInputProps } from "./types";
import * as styles from "./styles";

export const ComponentFilter = ({
  title,
  className = "",
  css,
  filters,
}: ComponentFilterProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const onSearch = useCallback((event: any, searchParams) => {
    const name = event.target.name;
    const value = event.target.value;

    let queries = Object.fromEntries([...searchParams]);
    queries = _.omit(
      {
        ...queries,
        [name]: value,
      },
      value === null || value === undefined ? [name] : []
    );

    const queryString =
      Object.keys(queries).length > 0
        ? `?${Object.keys(queries)
            .map((key) => key + "=" + queries[key])
            .join("&")}`
        : ``;

    let url = `/users${queryString}`;
    navigate(url);
  }, []);

  return (
    <div className={`filter ${className}`} css={[styles.filterContainer, css]}>
      <>
        {title && <p css={styles.filterTitle}>{title}</p>}
        {filters.map((filter, index) => {
          const isLastOne = index === 1;
          if (filter?.type === "options-buttons") {
            return (
              <FilterOptions
                key={index}
                onSearch={onSearch}
                isLastOne={isLastOne}
                value={searchParams.get(filter.name)}
                {...filter}
              />
            );
          } else {
            return (
              <FilterInput
                key={index}
                onSearch={onSearch}
                isLastOne={isLastOne}
                value={searchParams.get(filter.name)}
                {...filter}
              />
            );
          }
        })}
      </>
    </div>
  );
};

// Filter Inputs
const FilterInput = ({ isLastOne, onSearch, ...filter }: FilterInputProps) => {
  const [searchParams] = useSearchParams();

  return (
    <div css={styles.filterInputContainer(isLastOne)}>
      <input
        className="filter_input"
        css={styles.filterInput}
        name={filter.name}
        onChange={(e: any) => onSearch(e, searchParams)}
        value={filter.value || ""}
        placeholder={filter.placeholder}
        type={filter.type}
      />
    </div>
  );
};

const FilterOptions = ({
  isLastOne,
  onSearch,
  ...filter
}: FilterInputProps) => {
  const [searchParams] = useSearchParams();

  const getNextOption = (index: number) => {
    if (index === filter.options.length - 1) {
      return filter.options[0].value;
    } else {
      return filter.options[index + 1].value;
    }
  };

  let indexOption = 0;
  let optionSelected;

  filter?.options?.forEach((option, index) => {
    if (`${option.value}` === `${filter.value}`) {
      indexOption = index;
      optionSelected = option;
    }
  });

  if (!optionSelected) return <></>;

  return (
    <div css={styles.filterInputContainer(isLastOne)}>
      <button
        className="filter_button"
        css={styles.optionsButtons}
        name={filter.name}
        onClick={() =>
          onSearch(
            {
              target: {
                name: filter.name,
                type: filter.type,
                value: getNextOption(indexOption),
              },
            },
            searchParams
          )
        }
      >
        {optionSelected.label}
      </button>
    </div>
  );
};
